@if (row) {
  <div class="d-flex align-items-center z-1">
    <div class="d-flex align-items-center flex-column text-truncate w-100">
      <div>{{ row?.startValidityDate | momentDate: 'DD/MM/YYYY' }}</div>
      <div>{{ (445036 | apmTranslate) + ' ' + row?.revisionId }}</div>
      @if (row?.publicationLevel) {
        <apm-price-list-publish-level [level]="row?.publicationLevel"></apm-price-list-publish-level>
      }
    </div>
  </div>
}
